// .toLocaleString() gives Nu-Heat dates in American format, so we have to do it manually
export const getUkDateString = (date: Date) => {
  const dateInMonth = date.getDate();
  const day = dateInMonth < 10 ? `0${dateInMonth}` : dateInMonth;

  const month = date.getMonth() + 1;
  const monthString = month < 10 ? `0${month}` : month;

  return `${day}/${monthString}/${date.getFullYear()}`;
};
